import types from "./commonTypes";

export default {
  updateItems: items => ({
    type: types.UPDATE_ITEMS,
    items
  })
};
